import React, { useEffect, useState } from "react";
import { BiExport } from "react-icons/bi";
import { MdClear } from "react-icons/md";
import { useQuery } from "react-query";
import { DispositionReportApi, DownloadDispositionReportApi } from "../../Api";
import { AxiosResponse } from "axios";
import { RenderPaginationButtons } from "../../../Components/Paginations";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { formatDate as FormateDate } from "../../../helper/index";
import HelpText from "../../../Components/HelpText";


interface ReportDataType {
    id: number,
    number: string,
    status: string,
    // user_name: string,
    campaign_name: string,
    created_at: string,
    updated_at: string,
}

export default function MonitorDispositionStatusReports() {
    const [Data, setData] = useState<ReportDataType[]>([]);
    const { state } = useLocation();
    const navigate = useNavigate();

    const [info, setInfo] = useState<{
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    }>();
    const [Filter, setFilter] = useState<{
        number: string
        status: string,
        // user_name: string,
        campaign_name: string
    }>({
        number: "",
        status: "",
        // user_name: "",
        campaign_name: ""
    });
    const [page, setPage] = useState(1);

    const Report = useQuery({
        queryKey: ["Disposition-Report-Api-Report", state?.id, page, Filter],
        queryFn: DispositionReportApi,
        onSuccess: (resp: AxiosResponse) => {
            setData(resp.data?.data || []);
            setPage(resp.data?.info?.current_page || 1);
            setInfo(resp?.data?.info);
        },
        enabled: false,
    });

    const ReportDownload = useQuery({
        queryKey: ["Customer-Wise-Report-Download", state?.id, page, Filter],
        queryFn: DownloadDispositionReportApi,
        onSuccess: (resp: AxiosResponse) => {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(resp.data)
            link.download = `Disposition-Report_${new Date().toISOString()}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        enabled: false,
    });

    useEffect(() => {
        if (!state?.id) return navigate("/report/disposition-status/campaign-list");
        Report.refetch();
        // eslint-disable-next-line
    }, [page]);

    useEffect(() => {
        setPage(1)
        const handler = setTimeout(() => {
            Report.refetch();
        }, 300);

        return () => {
            clearTimeout(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Filter]);

    const handlePageChange = (page: number) => {
        if (page > 0 && page <= (info?.total_page || 1)) {
            setPage(page);
        }
    };

    const handleClearSearchFilter = () => {
        setFilter({
            number: "",
            status: "",
            // user_name: "",
            campaign_name: ""
        });
        Report.refetch();
    };

    return (
        <section className="content">
            <div className="container-fluid">
                <div className="card mt-4">
                    <div className="rounded-top bg-white p-3 d-md-flex justify-content-sm-between">
                        <div className="d-flex justify-content-between w-100 flex-wrap gap-3">
                            <h2 className="mb-0 fs-3 d-block d-md-inline">Disposition Report</h2>
                            <div className="d-flex gap-3 flex-wrap flex-grow-1 flex-md-grow-0">
                                <button
                                    onClick={handleClearSearchFilter}
                                    className="btn btn-secondary d-flex align-items-center justify-content-center gap-2"
                                    style={{ minWidth: 130 }}
                                >
                                    <MdClear className="fs-5" />
                                    Clear Filter
                                </button>
                                <button
                                    onClick={() => ReportDownload.refetch()}
                                    style={{ minWidth: 130 }}
                                    className="btn btn-success d-flex align-items-center justify-content-center gap-2 text-white"
                                    disabled={ReportDownload.isFetching}
                                >
                                    <BiExport className="fs-5" />
                                    {ReportDownload.isFetching ? "Exporting.." : "Export"}

                                </button>
                                <button
                                    onClick={() => navigate(-1)}
                                    className="btn btn-info text-white d-flex align-items-center fw-semibold"
                                >
                                    <IoMdArrowRoundBack /> Back
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body border-start-0 border-end-0 p-0">
                        <div className="table-responsive">
                            <table className="table table-hover table-bordered text-nowrap">
                                <thead>
                                    <tr>
                                        <th style={{ width: '20px' }}>SR No</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Campaign Name</th>
                                        {/* <th style={{ width: 200, minWidth: 200 }}>User Name</th> */}
                                        <th style={{ width: 200, minWidth: 200 }}>Customer Number</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Status</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Created At</th>
                                        <th style={{ width: 200, minWidth: 200 }}>Updated At</th>
                                        <th className="text-center" style={{ width: 150 }}>Actions</th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.campaign_name}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, campaign_name: e.target.value })
                                                }
                                            />
                                        </th>
                                        {/* <th>
                                            <input
                                                className="form-control"
                                                value={Filter.user_name}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, user_name: e.target.value })
                                                }
                                            />
                                        </th> */}
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.number}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, number: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th>
                                            <input
                                                className="form-control"
                                                value={Filter.status}
                                                onChange={(e) =>
                                                    setFilter({ ...Filter, status: e.target.value })
                                                }
                                            />
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {Data && Data[0] ? (
                                        Data.map((item, i) => (
                                            <tr>
                                                <td>{i + 1 + (page - 1) * 10}</td>
                                                <td>{item?.campaign_name || " - "}</td>
                                                {/* <td>{item?.user_name || " - "}</td> */}
                                                <td>{item?.number || " - "}</td>
                                                <td>{item?.status || " - "}</td>
                                                <td>{FormateDate(item?.created_at) || " - "}</td>
                                                <td>{FormateDate(item?.updated_at) || " - "}</td>
                                                <td className="text-center">
                                                    <Link
                                                        to={`/report/disposition-status/view/${item?.id}`}
                                                    >
                                                        <button className="ms-1 bg-transparent border-0 text-success fs-5">
                                                            <i data-tooltip-id={"View_Btn_" + i} className="fa-solid fa-eye"></i>
                                                            <HelpText id={"View_Btn_" + i} content="View Disposition" />
                                                        </button>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                    ) : !Report.isFetching ? (
                                        <tr>
                                            <td colSpan={7} height={50}>
                                                <div className="text-center">
                                                    <p className="mb-0 fs-5 fw-semibold">
                                                        No data found
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ) : null}
                                </tbody>
                            </table>
                            {Report.isFetching ? (
                                <center className="mb-3">
                                    <i
                                        className=" my-2 fa loader"
                                        style={{ fontSize: "30px", color: "black" }}
                                    ></i>
                                </center>
                            ) : null}
                        </div>
                        {info && info.total_page ? (
                            <div className="pagination d-flex flex-wrap justify-content-center align-items-center my-4 mx-3">
                                <RenderPaginationButtons
                                    info={info}
                                    currentPage={page}
                                    handlePageChange={handlePageChange}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
}
